/**
 * SF-4656 — PATCH one company from the company detail page.
 *
 * Calls the data provider directly instead of Refine's useUpdate. useUpdate
 * snapshots EVERY cached company query before the request and puts all of
 * them back if it fails, even in pessimistic mode, and cancels every company
 * read in flight. So company A's failed save could undo company B's
 * successful one in the cache (review finding). This writes nothing to the
 * cache itself: the caller writes the returned company into ITS company's
 * entry. The companies list is refreshed so it shows the change too (what
 * useUpdate's default invalidation did for it).
 */
import { useDataProvider, useInvalidate } from '@refinedev/core';
import { COMPANIES_META } from '../constants';
import type { Company } from '../list';

export function useCompanyPatch() {
  const dataProvider = useDataProvider();
  const invalidate = useInvalidate();
  return async (companyId: string, values: Partial<Company>): Promise<Company> => {
    const { data } = await dataProvider().update<Company, Partial<Company>>({
      resource: 'companies',
      id: companyId,
      variables: values,
      meta: COMPANIES_META,
    });
    void invalidate({ resource: 'companies', invalidates: ['list'] });
    return data;
  };
}
